import { useDebounce } from './useDebounce';

export default useDebounce;
